// @flow
import TicketingModalContent from 'components/fragments/modal/modalContents/TicketingModalContent';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/fragments/modal/modalContents/TicketingModalContent';

export default connect((state: StateType): StateProps => ({
  login_url: state.settingsState.login_url,
  userPref: state.userState.userPref
}))(TicketingModalContent);
